import { render } from "./PassengerInfo.vue?vue&type=template&id=e8021c0e"
import script from "./PassengerInfo.vue?vue&type=script&lang=js"
export * from "./PassengerInfo.vue?vue&type=script&lang=js"

import "./PassengerInfo.vue?vue&type=style&index=0&id=e8021c0e&lang=css"

import exportComponent from "D:\\react js\\VET_VUE\\VET-mini-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__